export default class OwnerDto {
    constructor(obj) {
        this.privateOwners = obj.privateOwners // Seq[PrivateOwner],
        this.companyOwners = obj.companyOwners // Seq[CompanyOwner]
    }
}